export const Type = {
  basesize: "16px",
  text: `'Roboto', sans-serif`,
  header: `'Merriweather', serif`,
}
